/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/9/14
 * Time: 7:31 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    require("connection-assets/js/LivepersonChatApi");

    var ConnectionPanelLayoutController = require("connection-controllers/ConnectionPanelLayoutController");
    var HandleController = require("connection-controllers/HandleController");
    var MainContainerController = require("connection-controllers/MainContainerController");
    var ConnectionPanelContextModel = require("connection-models/ConnectionPanelContextModel");
    var ArticleContainerController = require("connection-controllers/ArticleContainerController");
    var TicketExtendedContainerController = require("connection-controllers/ticketTab/TicketExtendedContainerController");
    var NotificationExtendedContainerController = require("connection-controllers/notificationTab/NotificationExtendedContainerController");
    var UsageTrackingController = require("connection-controllers/UsageTrackingController");
    var UsageTrackingModel = require("connection-models/UsageTrackingModel");
    var LiveEngageManager = require("connection-controllers/parentManagers/LiveEngageManager");
    var CP_CONST = require("connection-const");
    var Notifier = require("ui/notifier/Notifier");

    var ConnectionPanelController = {};
    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {
        ConnectionPanelController = Marionette.Controller.extend({

            initialize: function (options) {
                this.parentManager = new LiveEngageManager();
                this.visibility = this.parentManager.getVisibility();

                if(this.visibility[CP_CONST.VISIBILITY.KP] /*!== CP_CONST.VISIBILITY.NONE*/) {
                    LEConnection.contextModel = new ConnectionPanelContextModel();

                    this.listenTo(LEConnection.vent, 'layout:ready', this._onLayoutReady);


                    this.connectionPanelLayoutController = new ConnectionPanelLayoutController({
                        model: LEConnection.contextModel
                    });

                    this.parentManager.start( LEConnection.contextModel);

                    var modelAttrs = this.parentManager.getCurrentContext();
                    LEConnection.contextModel.set(modelAttrs);
                    LEConnection.parentManager = this.parentManager;

                    this._setControllers();

                    this._setEventListeners();
                    this._setNotifiers();

                    this._domainReady = true;
                    this._continueRendering();
                }
            },

            _onLayoutReady:function(){
                this._layoutIsReady = true;
                this._continueRendering();
            },

            _continueRendering:function(){
                if(this._domainReady && this._layoutIsReady){
                    LEConnection.vent.trigger("layout:domain:ready");
                }
            },

            getMainView: function () {
                if(this.visibility[CP_CONST.VISIBILITY.KP] /*!== CP_CONST.VISIBILITY.NONE*/) {
                    return this.connectionPanelLayoutController.getMainView();
                }
            },

            onLeave: function () {
                if(this.visibility[CP_CONST.VISIBILITY.KP] /*!== CP_CONST.VISIBILITY.NONE*/) {
                    this.parentManager.onLeave();
                }
            },

            _setControllers: function () {

                this.usageTrackingController = new UsageTrackingController({
                    model: LEConnection.contextModel
                });
                this.mainContainerController = new MainContainerController({
                    model: LEConnection.contextModel,
                    visibility:this.visibility
                });

                this.handleController = new HandleController({connectionPanelContextModel: LEConnection.contextModel});
                this.articleContainerController = new ArticleContainerController({
                    connectionPanelContextModel: LEConnection.contextModel
                });
                this.ticketExtendedContainerController = new TicketExtendedContainerController({
                    connectionPanelContextModel: LEConnection.contextModel
                });
                this.notificationExtendedContainerController = new NotificationExtendedContainerController({
                    connectionPanelContextModel: LEConnection.contextModel
                });
            },

            _setEventListeners: function () {
                LEConnection.on("kpSnippet:selected", this._setSelectedSnippet, this);
                LEConnection.on("ticket:selected", this._setSelectedTicket, this);
            },

            _setSelectedSnippet: function (options) {
                LEConnection.contextModel.setTopElement(CP_CONST.PAGE.ARTICLE);
                options = options || {};
                if (!_.isUndefined(options.snippetModel) && !_.isUndefined(options.type)) {
                    LEConnection.contextModel.set({
                        "referrerAction": options.type,
                        "selectedKP": options.snippetModel
                    });
                }
            },

            _setSelectedTicket:function (options) {
                options = options || {};
                if (!_.isUndefined(options.ticketModel) && !_.isUndefined(options.type)) {
                    LEConnection.contextModel.set({
                        "referrerAction": options.type,
                        "selectedTicket": options.ticketModel
                    });
                }
            },

            _setNotifiers: function () {
                var connectionNotifierError = LEConnection.notifier.showError;
                var connectionNotifierSuccess = LEConnection.notifier.showSuccess;
                var connectionNotifierInfo = LEConnection.notifier.showInfo;
                LEConnection.notifier.showErrorExtended = function (text) {
                    //Big one
                    //options.container = ".extended-ticket-view";
                    //options.top = 265;
                    //connectionNotifierError(options);

                    text = text || LE.translator.translate("LEConnection.general.notification.error");
                    return connectionNotifierError({
                        content: text,
                        container: ".connectionPanel-ticketContainer",
                        top: 0 //this is after the positioning calculation refactor of the Notifier
                    });
                };

                LEConnection.notifier.showSuccessExtended = function (text,timeToShow) {
                    return connectionNotifierSuccess({
                        content: text,
                        container: ".connectionPanel-ticketContainer",
                        timeToShow: timeToShow,
                        top: 0 //this is after the positioning calculation refactor of the Notifier
                    });
                };
                LEConnection.notifier.showInfoExtended = function (text) {
                    return connectionNotifierInfo({
                        content: text,
                        container: ".connectionPanel-ticketContainer",
                        top: 0 //this is after the positioning calculation refactor of the Notifier
                    });
                };

                LEConnection.notifier.showError = function (text) {
                    text = text || LE.translator.translate("LEConnection.general.notification.error");
                    connectionNotifierError({
                        content: text,
                        container: ".connection-panel-main-container",
                        top: 265 //this is after the positioning calculation refactor of the Notifier
                    });
                };
                LEConnection.notifier.showSuccess = function (text) {
                    connectionNotifierSuccess({
                        content: text,
                        container: ".connection-panel-main-container",
                        top: 265 //this is after the positioning calculation refactor of the Notifier
                    });
                };

            }
        });
    });

    return ConnectionPanelController;
});

